import { i18n } from "services/i18nService";
import { productionTransactionIsValid } from "services/sosInventoryService/productionTransaction/isValid";
import { quantitySerialsIsValid } from "services/utility/isValid";
import { isFinishedGoods } from "services/utility/jobWorkCenter";

import { ITEM_TYPES } from "appConstants";

export function isValid(record, __, ___, outputs, inputs) {
  let errors = productionTransactionIsValid(record, outputs, inputs);

  // Only validate serial numbers if the work center is "Finished Goods".
  // If the work center is not "Finished Goods", serials are not required regardless of auto-numbering.
  if (isFinishedGoods(record.workcenter)) {
    errors = quantitySerialsIsValid(
      errors,
      outputs,
      record.autoSerialLotNumbering,
      "output"
    );
  }

  errors = quantitySerialsIsValid(
    errors,
    inputs,
    record.autoSerialLotNumbering,
    "input"
  );

  if (outputs[0]?.itemDetails?.type === ITEM_TYPES.KIT) {
    errors.messages.push(i18n("isValid.NoKitsInBuildOutputs"));
  }

  return errors;
}
